import React, { ChangeEvent } from "react";
import styles from "./TextField.module.css";

export interface TextFieldProps {
  title: string;
  placeholder?: string;
  value: string;
  onChange: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  name: string;
  required?: boolean;
  type?: "text" | "password" | "email" | "number" | "tel";
  multiline?: boolean;
  rows?: number;
  error?: string;
}

const TextField: React.FC<TextFieldProps> = ({
  title,
  placeholder,
  value,
  onChange,
  name,
  required = false,
  type = "text",
  multiline = false,
  rows = 3,
  error = "",
}) => {
  const inputProps = {
    name,
    value,
    onChange,
    placeholder,
    required,
    className: `${styles.input} ${error ? styles.error : ""}`,
  };

  return (
    <div className={styles.fieldWrapper}>
      <label className={styles.label}>
        {title}
        {required && <span className={styles.required}>*</span>}
      </label>

      {multiline ? (
        <textarea {...inputProps} rows={rows} />
      ) : (
        <input {...inputProps} type={type} />
      )}

      {error && <p className={styles.errorMessage}>{error}</p>}
    </div>
  );
};

export default TextField;
